import { LayoutGrid, List } from 'lucide-react';
import { cn } from '@/lib/cn';
import type { ViewMode } from '@/hooks/useViewMode';

interface ViewModeToggleProps {
  mode: ViewMode;
  onChange: (mode: ViewMode) => void;
}

export function ViewModeToggle({ mode, onChange }: ViewModeToggleProps) {
  return (
    <div className="flex items-center rounded-lg border border-border/60 bg-secondary p-0.5">
      <button
        type="button"
        onClick={() => onChange('grid')}
        className={cn(
          'rounded-md p-1.5 transition-colors',
          mode === 'grid'
            ? 'bg-card text-foreground shadow-sm'
            : 'text-muted-foreground hover:text-foreground',
        )}
        title="Grid view"
      >
        <LayoutGrid className="h-3.5 w-3.5" />
      </button>
      <button
        type="button"
        onClick={() => onChange('list')}
        className={cn(
          'rounded-md p-1.5 transition-colors',
          mode === 'list'
            ? 'bg-card text-foreground shadow-sm'
            : 'text-muted-foreground hover:text-foreground',
        )}
        title="List view"
      >
        <List className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
